import {
  genderMenText,
  genderUnisexText,
  genderWomenText,
} from '@epicuro-next/constants/features/localization';

export const genderIcons = {
  Mens: {
    icon: null,
    label: genderMenText,
    className: 'gender-men font-weight-bold text-uppercase p-0',
  },
  Womens: {
    icon: null,
    label: genderWomenText,
    className: 'gender-women font-weight-bold text-uppercase p-0',
  },
  Unisex: {
    icon: null,
    label: genderUnisexText,
    className: 'gender-unisex font-weight-bold text-uppercase p-0',
  },
};
